import type IconNames from '@hapvida/hapvida-core-components/src/assets/icons/IconNames';
import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export enum UserStatusEnum {
  PENDING = 'Pending',
  ACTIVE = 'Active',
  ERROR = 'Error',
  PROCESSING = 'Processing',
}

export const USER_STATUS_NAME: Record<UserStatusEnum, string> = {
  [UserStatusEnum.PENDING]: 'Pendente',
  [UserStatusEnum.ACTIVE]: 'Ativo',
  [UserStatusEnum.ERROR]: 'Erro ao processar',
  [UserStatusEnum.PROCESSING]: 'Em processamento',
};

export const USER_STATUS_COLOR: Record<UserStatusEnum, string> = {
  [UserStatusEnum.PENDING]: NEW_COLORS.PRIMARY[700],
  [UserStatusEnum.ACTIVE]: NEW_COLORS.SEMANTICS.SUCCESS[700],
  [UserStatusEnum.ERROR]: NEW_COLORS.SEMANTICS.ERROR[500],
  [UserStatusEnum.PROCESSING]: NEW_COLORS.SECONDARY[500],
};

export const USER_STATUS_ICON_NAME: Record<UserStatusEnum, IconNames> = {
  [UserStatusEnum.ACTIVE]: 'actions-b2b-check-circle',
  [UserStatusEnum.PENDING]: 'actions-b2b-error-circle',
  [UserStatusEnum.ERROR]: 'actions-b2b-error-circle',
  [UserStatusEnum.PROCESSING]: 'actions-b2b-progress-clock',
};
